export default __webpack_public_path__ + "static/media/LeafBorder.7dbe782c.png";